import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadDataSourceSchema';
export const dataSourceSchemaActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
// Action Creators
export const dataSourceSchemaLoadAction = (workspaceId, dataSourceName) => {
    return {
        type: dataSourceSchemaActionTypes.LOAD,
        payload: { workspaceId: workspaceId, dataSourceName: dataSourceName },
    };
};
export const dataSourceSchemaLoadingAction = (payload) => {
    return {
        type: dataSourceSchemaActionTypes.LOADING,
        payload: payload,
    };
};
export const dataSourceSchemaLoadedAction = (payload, result) => {
    return {
        type: dataSourceSchemaActionTypes.LOADED,
        payload: {
            items: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case dataSourceSchemaActionTypes.LOADING:
            return {
                ...state,
                items: {
                    ...state.items,
                    status: AsyncRequestStatus.Pending,
                },
            };
        case dataSourceSchemaActionTypes.LOADED:
            const loadedAction = action;
            return {
                ...state,
                items: loadedAction.payload.items,
            };
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=DataSourceDetailSchema.ducks.js.map
